module.exports = __webpack_public_path__ + "img/21.648ee9d0.png";